import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { IS_DEVELOPMENT } from '@/constants/configs';

import englishTranslation from '@/i18n/locales/default/en/translation.json';
import dutchTranslation from '@/i18n/locales/default/nl/translation.json';

import { Language } from '@/types/i18n';

export const SupportedLanguages = [Language.English, Language.Dutch];
export const NAME_SPACES = ['translation', 'idmission'];

export const defaultResources = {
  [Language.English]: {
    translation: englishTranslation,
    idmission: {},
  },
  [Language.Dutch]: {
    translation: dutchTranslation,
    idmission: {},
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: defaultResources,
    fallbackLng: Language.English,
    interpolation: {
      escapeValue: false,
    },
    defaultNS: 'translation',
    ns: NAME_SPACES,
    supportedLngs: SupportedLanguages,
    debug: IS_DEVELOPMENT,
    // Without this, useTranslation does not re-render when tenant strings are
    // merged in via addResourceBundle (same language as before).
    react: {
      bindI18nStore: 'added removed',
    },
  });

export default i18n;
